import BasicExample from '../components/Navigation-home';

function Home() {
  return (
    <BasicExample />
  );
}

export default Home;
